<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >
    <b-container fluid>
      <iframe
        :src="pdf_to_print"
        id="myFrame_sku"
        frameborder="0"
        style="display: none"
        width="300"
        height="300"
      >
      </iframe>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items" />

      <b-card class="mb-1">
        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Vendor ID</strong>
          </b-col>
          <b-col>
            {{ inbound_shipment.vendor_id }}
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col class="col-2">
            <strong>Shipment Type</strong>
          </b-col>
          <b-col>
            {{ inbound_shipment.shipment_type }}
          </b-col>
        </b-row>
      </b-card>

      <h4 class="mt-3">Products</h4>

      <b-card>
        <div class="mb-3">
          <b-row>
            <b-col cols="2" class="">
              <!-- <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="updateProductsStatus('confirmed')"
                v-if="
                  $store.state.user_obj.account_type == 'admin' ||
                    $store.state.user_obj.account_type == 'logistic'
                "
                >Mark as Confirmed</b-button
              >

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="updateProductsStatus('attention')"
                v-if="
                  $store.state.user_obj.account_type == 'admin' ||
                    $store.state.user_obj.account_type == 'logistic'
                "
                >Mark as "Attention Required"</b-button
              > -->

              <!-- <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="addProductRow"
                >Add Product Row</b-button
              > -->

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="showModal_createShipment"
                >Create Shipment Record</b-button
              >
            </b-col>
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="product_search_criteria.status_selected"
                :options="product_status_options"
              />
            </b-col>
            <b-col cols="4" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="SKU / Description"
                v-model="product_search_criteria.keyword"
              ></b-form-input>
            </b-col>
            <b-col class="text-left p-0">
              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="getInbound_Shipment_Products"
              >
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>

              <b-button
                class="btn-action"
                size="sm"
                variant="info"
                @click="onExport"
              >
                Export
              </b-button>
            </b-col>
          </b-row>
        </div>
        <b-table
          responsive
          small
          outlined
          striped
          hover
          sticky-header="400px"
          :items="product_items"
          :fields="product_fields"
        >
          <template v-slot:head(chk_box)="data">
            <b-form-checkbox
              size="sm"
              plain
              id="chkbox_all"
              value="all"
              v-model="check_all_products"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(chk_box)="data">
            <b-form-checkbox
              size="sm"
              class="chkbox_row"
              plain
              :id="'chkbox_row_' + data.index"
              v-model="data.item.is_checked"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(item_number)="data">
            {{ data.item.item_number }}
            <!-- <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_number"
            ></b-form-input> -->
          </template>

          <template v-slot:cell(item_description)="data">
            <div
              class="text-ellipsis"
              v-b-tooltip.hover.right
              :title="data.item.item_description"
            >
              {{ data.item.item_description }}
            </div>
          </template>

          <template v-slot:cell(received_at)="data">
            {{ displayDate(data.item.received_at) }}
          </template>

          <template v-slot:cell(supplier_lot)="data">
            <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.supplier_lot"
            ></b-form-input>
          </template>

          <template v-slot:cell(eta)="data">
            {{ displayDate(data.item.eta) }}
          </template>

          <template v-slot:cell(expected_qty)="data">
            <div style="display: flex">
              <div style="flex: 0 0 20px">
                <span
                  v-if="data.item.gols_qty == 0 && data.item.cancel_at == null"
                  class="dot_yellow"
                ></span>
                <span
                  v-if="
                    (data.item.gols_qty != 0 &&
                      data.item.gols_qty - data.item.expected_qty != 0) ||
                    data.item.cancel_at != null
                  "
                  class="dot_red"
                ></span>
                <span
                  v-if="
                    data.item.gols_qty != 0 &&
                    data.item.gols_qty - data.item.expected_qty == 0
                  "
                  class="dot_green"
                ></span>
              </div>
              <div>
                <span>{{ data.item.expected_qty - data.item.gols_qty }}</span>
              </div>
            </div>
          </template>

          <template v-slot:cell(action)="data">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="showModal_newExpectedQty(data.item)"
              >Amend Exp. QTY</b-button
            >

            <b-button
              class="btn-action"
              size="sm"
              variant="danger"
              @click="showModal_cancelProduct(data.item)"
              >Cancel Product</b-button
            >

            <!-- <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="cancelProduct(data.item)"
              >Cancel</b-button
            > -->
          </template>
        </b-table>
      </b-card>

      <h4 class="mt-3">Shipment Record</h4>
      <b-card>
        <b-pagination
          size="sm"
          :total-rows="total_rows_ShipmentRecord"
          v-model="currentPage_ShipmentRecord"
          :per-page="TABLE_LIMIT"
          @change="onPageChange_ShipmentRecord"
          :limit="PAGING_LIMIT"
        ></b-pagination>

        <b-table
          responsive
          small
          outlined
          striped
          hover
          :items="inbound_shipment_dns"
          :fields="inbound_shipment_dns_fields"
        >
          <template v-slot:cell(diff_qty)="data">
            <div style="display: flex">
              <div style="flex: 0 0 20px">
                <span v-if="data.item.gols_qty == 0" class="dot_yellow"></span>
                <span
                  v-if="data.item.gols_qty != 0 && data.item.diff_qty != 0"
                  class="dot_red"
                ></span>
                <span
                  v-if="data.item.gols_qty != 0 && data.item.diff_qty == 0"
                  class="dot_green"
                ></span>
              </div>
              <div>
                <span>{{ data.item.diff_qty }}</span>
              </div>
            </div>
          </template>
          <template v-slot:cell(received_at)="data">
            {{ displayDate(data.item.received_at) }}
          </template>
          <template v-slot:cell(action)="data">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              :to="{
                name: 'inbound_shipment_dn',
                params: {
                  inbound_shipment_id: data.item.id,
                  dn_id: data.item.id,
                },
              }"
              >Detail</b-button
            >
          </template>
        </b-table>
      </b-card>

      <b-modal ref="modal_cancelProduct" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <strong>Are you sure to delete product?</strong>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="col-4">
              <strong>Product SKU:</strong>
            </b-col>
            <b-col>{{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col class="col-4">
              <strong>Other SKU:</strong>
            </b-col>
            <b-col>{{ updating_item.other_sku }}</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_cancelProduct"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="cancelProduct(updating_item)"
            >Confirm</b-btn
          >
        </div>
      </b-modal>

      <b-modal
        ref="modal_createShipment"
        centered
        hide-footer
        hide-header
        size="xl"
      >
        <div class="d-block">
          <b-row class="mb-2">
            <b-col class="col-2">
              <strong>Vendor ID</strong>
            </b-col>
            <b-col>{{ inbound_shipment.vendor_id }}</b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="col-2">
              <strong>Shipment Type</strong>
            </b-col>
            <b-col>{{ inbound_shipment.shipment_type }}</b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="col-2">
              <strong>Shipment#</strong>
            </b-col>
            <b-col
              ><b-form-input
                size="sm"
                type="text"
                placeholder
                v-model="shipment_record_obj.shipment_no"
              ></b-form-input
            ></b-col>
          </b-row>

          <b-row class="mb-2">
            <b-col class="col-2">
              <strong>Receive at</strong>
            </b-col>
            <b-col
              ><b-form-input
                size="sm"
                type="date"
                placeholder
                v-model="shipment_record_obj.received_at"
              ></b-form-input
            ></b-col>
          </b-row>
          <hr />

          <b-table
            responsive
            small
            outlined
            striped
            hover
            :items="shipment_record_obj.products"
            :fields="shipment_product_fields"
            id="btable_inbound_shipment_create"
            ref="btable_inbound_shipment_create"
          >
            <template v-slot:head(chk_box)="data">
              <b-form-checkbox
                size="sm"
                plain
                id="chkbox_all"
                value="all"
                v-model="check_all_products"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(chk_box)="data">
              <b-form-checkbox
                size="sm"
                class="chkbox_row"
                plain
                :id="'chkbox_row_' + data.index"
                v-model="data.item.is_checked"
              ></b-form-checkbox>
            </template>
            <template v-slot:cell(item_number)="data">
              {{ data.item.item_number }}
              <!-- <b-form-input
              size="sm"
              type="text"
              required
              placeholder
              v-model="data.item.item_number"
            ></b-form-input> -->
            </template>

            <template v-slot:cell(print_sku)="data">
              <b-button
                size="sm"
                class=""
                variant="info"
                @click="showModal_printQty(data.item, data.index)"
                >Print</b-button
              >
            </template>

            <template v-slot:cell(product_sku)="data">
              {{ data.item.product_sku }}
            </template>

            <template v-slot:cell(item_description)="data">
              <div
                class="text-ellipsis"
                v-b-tooltip.hover.right
                :title="data.item.item_description"
              >
                {{ data.item.item_description }}
              </div>
            </template>

            <template v-slot:cell(gols_qty)="data">
              <b-row
                class="mb-1"
                no-gutters
                :key="qty_group_i"
                v-for="(qty_group, qty_group_i) in data.item.qty_groups"
              >
                <b-col cols="2">
                  <b-form-input
                    type="text"
                    required
                    size="sm"
                    placeholder="Quantity"
                    v-model="qty_group.quantity"
                  ></b-form-input>
                </b-col>
                <b-col cols="2">
                  <b-form-input
                    type="text"
                    required
                    size="sm"
                    placeholder="Lot#"
                    v-model="qty_group.lot_number"
                  ></b-form-input>
                </b-col>
                <b-col cols="3">
                  <!-- <b-form-input
                  type="text"
                  required
                  placeholder="Type"
                  v-model="qty_group.inventory_type"
                ></b-form-input> -->
                  <b-form-select
                    size="sm"
                    v-model="qty_group.inventory_type"
                    :options="inventory_type_options"
                  />
                </b-col>
                <b-col cols="2">
                  <b-form-input
                    type="text"
                    required
                    size="sm"
                    placeholder="Location"
                    v-model="qty_group.location"
                  ></b-form-input>
                  <!-- <b-form-select
                    size="sm"
                    v-model="qty_group.location"
                    :options="location_options"
                  /> -->
                </b-col>
                <b-col cols="2">
                  <b-button
                    class="btn-action"
                    variant="info"
                    size="sm"
                    @click="showModal_ExpDateInput(qty_group, qty_group_i)"
                  >
                    <span
                      class="dot_green"
                      v-if="
                        !(
                          !qty_group.expiration_date ||
                          qty_group.expiration_date == null ||
                          qty_group.expiration_date == '0000-00-00' ||
                          qty_group.expiration_date == '1970-01-01' ||
                          qty_group.expiration_date == 'Invalid date' ||
                          qty_group.expiration_date == ''
                        )
                      "
                    ></span>
                    <span
                      class="dot_red"
                      v-if="
                        !qty_group.expiration_date ||
                        qty_group.expiration_date == null ||
                        qty_group.expiration_date == '0000-00-00' ||
                        qty_group.expiration_date == '1970-01-01' ||
                        qty_group.expiration_date == 'Invalid date' ||
                        qty_group.expiration_date == ''
                      "
                    ></span>

                    <!-- WORD -->
                    <span
                      v-if="
                        !(
                          !qty_group.expiration_date ||
                          qty_group.expiration_date == null ||
                          qty_group.expiration_date == '0000-00-00' ||
                          qty_group.expiration_date == '1970-01-01' ||
                          qty_group.expiration_date == 'Invalid date' ||
                          qty_group.expiration_date == ''
                        )
                      "
                    >
                      {{ qty_group.expiration_date }}
                    </span>
                    <span
                      v-if="
                        !qty_group.expiration_date ||
                        qty_group.expiration_date == null ||
                        qty_group.expiration_date == '0000-00-00' ||
                        qty_group.expiration_date == '1970-01-01' ||
                        qty_group.expiration_date == 'Invalid date' ||
                        qty_group.expiration_date == ''
                      "
                    >
                      Exp. Date</span
                    >
                    <!-- Exp. Date -->
                  </b-button>
                </b-col>
              </b-row>
            </template>

            <template v-slot:cell(split_qty)="data">
              <b-button
                size="sm"
                class=""
                variant="info"
                @click="addQtyRow(data.item, data.index)"
                >Split</b-button
              >
            </template>
            <template v-slot:cell(supplier_lot)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.supplier_lot"
              ></b-form-input>
            </template>

            <template v-slot:cell(expiration_date)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.expiration_date"
              ></b-form-input>
            </template>

            <template v-slot:cell(product_remark)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.product_remark"
              ></b-form-input>
            </template>

            <template v-slot:cell(diff_qty)="data">
              <span v-if="data.item.gols_qty == 0" class="dot_yellow"></span>
              <span
                v-if="
                  data.item.gols_qty != 0 &&
                  data.item.gols_qty - data.item.expected_qty != 0
                "
                class="dot_red"
              ></span>
              <span
                v-if="
                  data.item.gols_qty != 0 &&
                  data.item.gols_qty - data.item.expected_qty == 0
                "
                class="dot_green"
              ></span>

              <span>{{ data.item.gols_qty - data.item.expected_qty }}</span>
            </template>

            <template v-slot:cell(cover_image)="data">
              <img :src="data.item.cover_image" width="50" />
            </template>

            <template v-slot:cell(lot_number)="data">
              <b-form-input
                size="sm"
                type="text"
                required
                placeholder
                v-model="data.item.lot_number"
              ></b-form-input>
            </template>

            <template v-slot:cell(inventory_type)="data">
              <b-form-select
                size="sm"
                v-model="data.item.inventory_type"
                :options="inventory_type_options"
              />
            </template>

            <template v-slot:cell(location)="data">
              <b-form-select
                size="sm"
                v-model="data.item.location"
                :options="location_options"
              />
            </template>

            <template v-slot:cell(size)="data">
              <b-button
                class=""
                variant="info"
                size="sm"
                @click="showModal_sizeInput(data.item, data.index)"
              >
                <span
                  @click="showModal_sizeInput(data.item, data.index)"
                  class="dot_green"
                  v-if="
                    data.item.height_cm &&
                    data.item.width_cm &&
                    data.item.depth_cm
                  "
                ></span>
                <span
                  class="dot_red"
                  v-if="
                    !data.item.height_cm ||
                    !data.item.width_cm ||
                    !data.item.depth_cm
                  "
                ></span>
                Edit</b-button
              >
            </template>

            <template v-slot:cell(weight)="data">
              <b-button
                style="min-width: 54px; text-align: left"
                class=""
                variant="info"
                size="sm"
                @click="showModal_weightInput(data.item, data.index)"
              >
                <span
                  class="dot_green"
                  v-if="data.item.actual_weight_kg"
                ></span>
                <span class="dot_red" v-if="!data.item.actual_weight_kg"></span>
                <span v-if="data.item.actual_weight_kg">{{
                  data.item.actual_weight_kg
                }}</span>

                <span class="" v-if="!data.item.actual_weight_kg">Edit</span>
              </b-button>
            </template>
          </b-table>

          <!-- <h4 class="mt-3">Documents</h4>
          <b-card>
            <div class="search_bar mb-3">
              <b-row>
                <b-col cols="2" class="pr-1">
                  <b-form-input
                    id="input-small"
                    type="text"
                    placeholder="Document Name"
                    v-model="new_doc_record.name"
                  ></b-form-input>
                </b-col>
                <b-col cols="3" class="pl-0 pr-1">
                  <b-form-file
                    v-model="new_doc_record.upload_file"
                    placeholder="Choose a file..."
                  ></b-form-file>
                </b-col>

                <b-col class="text-left p-0">
                  <b-button
                    class="btn-action"
                    variant="info"
                    @click="onUploadFile"
                    >Upload</b-button
                  >
                </b-col>
              </b-row>
            </div>
            <b-table
              responsive
              small
              outlined
              striped
              hover
              :items="document_items"
              :fields="document_fields"
            >
              <template v-slot:cell(document_name)="data">
                <a :href="data.item.url" target="_blank">
                  {{ data.item.document_name }}
                </a>
              </template>

              <template v-slot:cell(created_at)="data">
                <div v-if="data.item.updated_by != ''">
                  {{ data.item.created_at }}
                </div>
              </template>
            </b-table>
          </b-card> -->
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_createShipment"
            >Cancel</b-btn
          >
          <b-btn
            :disabled="form_submitted"
            class="mt-3"
            variant="outline-success"
            @click="createShipment_tick()"
            >Submit</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_newExpectedQty" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col
              ><b-form-input
                class=""
                size="sm"
                type="text"
                placeholder="NEW Expected QTY"
                v-model="updating_item.new_expected_qty"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_newExpectedQty"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="amendProduct(updating_item)"
            >Submit</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_sizeInput" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Height"
                v-model="updating_item.height_cm"
              ></b-form-input
            ></b-col>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Width"
                v-model="updating_item.width_cm"
              ></b-form-input
            ></b-col>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Depth"
                v-model="updating_item.depth_cm"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_sizeInput"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="sizeInput()"
            >OK</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_weightInput" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Weight"
                v-model="updating_item.actual_weight_kg"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_weightInput"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="weightInput()"
            >OK</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_ExpDateInput" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="5"
              ><b-form-input
                class="center_align"
                size="sm"
                type="date"
                placeholder="Expiry Date"
                v-model="updating_item.expiration_date"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_ExpDateInput"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="doExpDateInput()"
            >OK</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_printQty" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>QTY to Print: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Weight"
                v-model="updating_item.qty_to_print"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_printQty"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="printSKU(updating_item)"
            >OK</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "order_id",
    label: "Order#",
  },
  {
    key: "barcode",
    label: "Barcode",
  },
  {
    key: "attention",
    label: "Attention",
  },
  {
    key: "phone",
    label: "Phone",
  },
  {
    key: "status",
    label: "Status",
  },
  {
    key: "schedule_date",
    label: "Scheduled Date",
  },
  {
    key: "pod_image",
    label: "POD Record",
  },
  {
    key: "carried_by",
    label: "Carried by",
  },
  {
    key: "updated_at",
    label: "Last Updated",
  },
];

import CsIssue_Card from "../components/CsIssue_Card.vue";

export default {
  name: "InboundShipment",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode,
    "cs-issue-card": CsIssue_Card,
  },
  data() {
    return {
      currentPage_ShipmentRecord: 1,
      total_rows_ShipmentRecord: 0,
      table_offset_ShipmentRecord: 0,
      pdf_to_print: false,
      shipment_record_obj: {
        shipment_no: "",
        products: [],
        dn_no: "",
        received_at: moment().format("YYYY-MM-DD"),
      },
      new_doc_record: {},
      updating_item: false,
      breadcrumb_items: [
        {
          text: "Inbound Shipment",
          to: { name: "inbound_shipments" },
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      document_items: [],
      document_fields: [
        {
          key: "document_name",
          label: "Document Name",
        },
        {
          key: "created_by",
          label: "Created By",
        },
        {
          key: "created_at",
          label: "Created at",
        },
      ],

      inbound_shipment_dns: [],
      inbound_shipment_dns_fields: [
        {
          key: "shipment_no",
          label: "Shipment#",
        },
        {
          key: "gols_qty",
          label: "Received QTY",
        },
        {
          key: "adjustment_qty",
          label: "Adjustment QTY",
        },
        {
          key: "diff_qty",
          label: "Diff QTY",
        },
        {
          key: "received_at",
          label: "Received at",
        },
        {
          key: "action",
          label: "Action",
        },
      ],

      product_items: [],
      product_fields: [
        {
          key: "chk_box",
          label: "",
        },
        {
          key: "dn_no",
          label: "DN#",
          class: "",
        },
        {
          key: "product_sku",
          label: "Product SKU",
        },
        // {
        //   key: "channel_sku",
        //   label: "Channel SKU"
        // },
        {
          key: "other_sku",
          label: "Other SKU",
        },
        {
          key: "item_description",
          label: "Description",
          class: "td_maxwidth150",
        },
        {
          key: "expected_qty",
          label: "Expected QTY",
          class: "",
        },
        {
          key: "eta",
          label: "ETA",
          class: "center_align",
        },
        {
          key: "gols_qty",
          label: "Received QTY",
          class: "center_align",
        },
        {
          key: "adjustment_qty",
          label: "Adjustment QTY",
          class: "center_align",
        },
        {
          key: "received_at",
          label: "Received Date",
          class: "center_align",
        },
        {
          key: "created_at",
          label: "Upload Date",
          class: "center_align",
        },
        {
          key: "action",
          label: "Action",
          class: "",
        },
        // {
        //   key: "product_remark",
        //   label: "Remark"
        // },
        // {
        //   key: "status",
        //   label: "Status"
        // }
      ],
      shipment_product_fields: [
        {
          key: "print_sku",
          label: "",
        },

        {
          key: "product_sku",
          label: "Product SKU",
        },
        // {
        //   key: "channel_sku",
        //   label: "Channel SKU"
        // },
        {
          key: "other_sku",
          label: "Other SKU",
        },
        {
          key: "item_description",
          label: "Description",
          class: "td_maxwidth300x",
        },
        {
          key: "expected_qty",
          label: "QTY",
          class: "center_align",
        },
        {
          key: "gols_qty",
          label: "Received QTY",
          class: "center_align",
        },
        {
          key: "adjustment_qty",
          label: "Adjustment QTY",
          class: "center_align",
        },
        // {
        //   key: "lot_number",
        //   label: "Lot#",
        // },
        // {
        //   key: "inventory_type",
        //   label: "Type",
        // },
        // {
        //   key: "location",
        //   label: "Location",
        // },
        {
          key: "split_qty",
          label: "Split",
        },
        {
          key: "size",
          label: "Size",
        },
        {
          key: "weight",
          label: "Weight",
        },
        // {
        //   key: "expiration_date",
        //   label: "Expiry Date",
        // },
        {
          key: "product_remark",
          label: "Remark",
        },
      ],
      loader: false,
      items: [{ id: false }],
      inbound_shipment: { id: false },
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      manual_return_order_id: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null,
      },
      product_search_criteria: {
        status_selected: "pending",
        keyword: null,
      },
      product_status_options: [
        {
          value: null,
          text: "All Items",
        },
        {
          value: "pending",
          text: "Pending Items",
        },
        {
          value: "received",
          text: "Received Items",
        },
        {
          value: "cancel",
          text: "Cancel Items",
        },
      ],
      inventory_type_options: [
        {
          value: "Active",
          text: "Active",
        },
        {
          value: "Damaged",
          text: "Damaged",
        },
        {
          value: "Hold",
          text: "Hold",
        },
        {
          value: "Expired",
          text: "Expired",
        },
      ],
      status_options: [
        {
          value: null,
          text: "All Status",
        },
        {
          value: "Pending",
          text: "Pending",
        },
        {
          value: "In-Transit",
          text: "In-Transit",
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse",
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery",
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse",
        },
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before",
        },
        {
          value: "on",
          text: "on",
        },
        {
          value: "after",
          text: "after",
        },
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",
      document_file: [],
      file_document: false,
      location_options: [],
      check_all_products: false,
      form_submitted: false,
    };
  },
  async created() {
    await this.getInbound_Shipment();
    await this.getInbound_Shipment_Products();
    await this.getInbound_Shipment_Docs();
    await this.getInbound_Shipment_DN();
    await this.getWMS_Locations();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_products: function (new_val, old_val) {
      // this.check_all_products = !this.check_all_products;
      console.log("check_all_products");
      if (new_val == "all") {
        // Check all
        for (let i in this.product_items) {
          this.product_items[i].is_checked = true;
        }
      } else {
        for (let i in this.product_items) {
          this.product_items[i].is_checked = false;
        }
      }
      console.log(this.product_items);
    },
  },
  methods: {
    displayDate(d) {
      if (d) {
        if (moment(d).format("YYYY-MM-DD") == "Invalid date") {
          return d;
        } else {
          return moment(d).format("YYYY-MM-DD");
        }
      } else {
        return "-";
      }
    },

    async getInbound_Shipment() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      this.inbound_shipment = response.data.inbound_shipments[0];
      this.items.push(this.inbound_shipment);

      this.loader.hide();
    },

    async getInbound_Shipment_DN() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          offset: this.table_offset_ShipmentRecord,
          limit: this.TABLE_LIMIT,
        },
      });
      this.inbound_shipment_dns = response.data.inbound_shipment_dns;
      this.total_rows_ShipmentRecord = parseInt(response.data.total_rows);

      this.loader.hide();
    },

    async getInbound_Shipment_Products() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_product_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          search_criteria: this.product_search_criteria,
        },
      });
      for (let i in response.data.inbound_shipment_products) {
        if (
          !response.data.inbound_shipment_products[i].qty_groups ||
          response.data.inbound_shipment_products[i].qty_groups.length == 0
        ) {
          response.data.inbound_shipment_products[i].qty_groups = [
            {
              product_sku:
                response.data.inbound_shipment_products[i].product_sku,
              quantity: response.data.inbound_shipment_products[i].expected_qty,
              inventory_type: "Active",
              lot_number: response.data.inbound_shipment_products[i].lot_number,
              location: response.data.inbound_shipment_products[i].location,
              expiration_date:
                response.data.inbound_shipment_products[i].expiration_date,
              expirylot_mandate:
                response.data.inbound_shipment_products[i].expirylot_mandate,
            },
          ];
        }
      }
      this.product_items = response.data.inbound_shipment_products;

      this.loader.hide();
    },

    async getInbound_Shipment_Docs() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_doc_get.php",
        data: {
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      this.document_items = response.data.inbound_shipment_docs;

      this.loader.hide();
    },

    async updateProductsInfo() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });
      console.log(this.product_items);

      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        product_items: this.product_items,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id,
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_info.php",
        data: params,
      });
      this.loader_full.hide();
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
    },

    async updateProductsStatus(status) {
      let params = {
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        product_items: this.product_items,
        user_id: this.$store.state.user_obj.user_id,
        status: status,
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_status.php",
        data: params,
      });

      this.getInbound_Shipment_Products();
    },

    async updateInvoiceStatus() {
      let params = {
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        invoice_no: this.inbound_shipment.invoice_no,
        user_id: this.$store.state.user_obj.user_id,
        status: "received",
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_invoice_status.php",
        data: params,
      });

      this.getInbound_Shipment();
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("doc_file", this.new_doc_record.upload_file);
      formData.append("document_name", this.new_doc_record.name);
      formData.append("waybill_no", this.inbound_shipment.waybill_no);
      formData.append("user_id", this.$store.state.user_obj.user_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_upload_document.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });
      console.log(response);
      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        // window.location.reload();
      }

      this.getInbound_Shipment_Docs();
    },

    addQtyRow(item, item_index) {
      console.log("addQtyRow");
      this.shipment_record_obj.products[item_index].qty_groups.push({
        product_sku: this.shipment_record_obj.products[item_index].product_sku,
        quantity: 0,
        inventory_type: "Active",
        lot_number: "-",
        location: "-",
        expiration_date: "",
      });
      // this.$root.$emit('bv::refresh::table', 'btable_inbound_shipment_create');
      this.$refs.btable_inbound_shipment_create.refresh();
    },

    addProductRow() {
      this.product_items.push({});
    },

    async getWMS_Locations() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_location_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
        },
      });

      this.location_options = [
        {
          value: "-",
          text: "-",
        },
      ];

      for (let i in response.data.locations) {
        let location_obj = {
          value: response.data.locations[i].location_code,
          text: response.data.locations[i].location_code,
        };

        this.location_options.push(location_obj);
      }
    },
    downloadDoc(item) {
      let download_url = item.url;
      window.open(download_url, "_blank");
    },

    showModal_createShipment() {
      this.shipment_record_obj = {
        shipment_no: "",
        products: [],
        dn_no: "",
        received_at: moment().format("YYYY-MM-DD"),
      };

      // get checked items
      for (let i in this.product_items) {
        if (this.product_items[i].is_checked) {
          this.shipment_record_obj.products.push(
            JSON.parse(JSON.stringify(this.product_items[i]))
          );
        }
      }

      if (this.shipment_record_obj.products.length == 0) {
        return;
      }

      this.$refs.modal_createShipment.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_createShipment() {
      this.$refs.modal_createShipment.hide();
    },

    async createShipment_tick(){
      this.$nextTick(() => {
        this.createShipment();
      });
    },

    async createShipment() {
      console.log(this.shipment_record_obj);
      if (
        !this.shipment_record_obj.shipment_no ||
        this.shipment_record_obj.shipment_no == ""
      ) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Please enter shipment number",
        });
        return;
      }

      // check if lot & exp date if flag [expirylot_mandate] is ON
      console.log(this.shipment_record_obj.products);
      for (let i in this.shipment_record_obj.products) {
        let sr_product = this.shipment_record_obj.products[i];
        if (sr_product.expirylot_mandate == "1") {
          for (let i2 in sr_product.qty_groups) {
            let sr_product_qg = sr_product.qty_groups[i2];
            if (
              sr_product_qg.expiration_date == null ||
              sr_product_qg.expiration_date == "0000-00-00"
            ) {
              this.$eventHub.$emit("show_modal_message", {
                message_content: "Please enter expiration date",
              });
              return;
            }

            if (
              sr_product_qg.lot_number == null ||
              sr_product_qg.lot_number == "" ||
              sr_product_qg.lot_number == "-"
            ) {
              this.$eventHub.$emit("show_modal_message", {
                message_content: "Please enter lot number",
              });
              return;
            }

            console.log(moment(sr_product_qg.expiration_date));
            console.log(moment().add(6, "months").format("YYYY-MM-DD"));
            if (
              moment(sr_product_qg.expiration_date).isBefore(
                moment().add(6, "months").format("YYYY-MM-DD")
              )
            ) {
              this.$eventHub.$emit("show_modal_message", {
                message_content: "expiration date is within 6 months",
              });
            }
          }
        }

        if (
          sr_product.actual_weight_kg == null ||
          sr_product.actual_weight_kg == "" ||
          sr_product.actual_weight_kg == "0"
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Please enter weight",
          });
          return;
        }
      }

      this.form_submitted = true;
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        shipment_no: this.shipment_record_obj.shipment_no,
        received_at: this.shipment_record_obj.received_at,
        product_items: this.shipment_record_obj.products,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id,
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_update_product_info.php",
        data: params,
      });

      this.loader_full.hide();

      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
      // this.getInbound_Shipment_DN();

      this.hideModal_createShipment();
      this.form_submitted = false;
    },

    showModal_newExpectedQty(item) {
      this.updating_item = item;
      this.$refs.modal_newExpectedQty.show();
    },

    hideModal_newExpectedQty() {
      this.$refs.modal_newExpectedQty.hide();
    },

    async amendProduct(item) {
      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        dn_no: this.shipment_record_obj.dn_no,
        new_expected_qty: item.new_expected_qty,
        item: item,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id,
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_dn_amend.php",
        data: params,
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
      this.hideModal_newExpectedQty();
    },

    showModal_cancelProduct(item) {
      this.updating_item = item;
      this.$refs.modal_cancelProduct.show();
    },

    hideModal_cancelProduct() {
      this.$refs.modal_cancelProduct.hide();
    },

    async cancelProduct(item) {
      let params = {
        // invoice_status : invoice_status,
        inbound_shipment: this.inbound_shipment,
        inbound_shipment_id: this.$route.params.inbound_shipment_id,
        account_type: this.$store.state.user_obj.account_type,
        item: item,
        user_id: this.$store.state.user_obj.user_id,
        client_id: this.$store.state.user_obj.client_id,
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "inbound_shipment_product_cancel.php",
        data: params,
      });
      this.getInbound_Shipment();
      this.getInbound_Shipment_Products();
      this.hideModal_cancelProduct();
    },

    onExport() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "inbound_shipment_supplier",
          limit: 999999,
          inbound_shipment_id: this.$route.params.inbound_shipment_id,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
          search_criteria: this.product_search_criteria,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "inbound_shipment_supplier.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    showModal_sizeInput(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item_i = item_i;
      this.$refs.modal_sizeInput.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_sizeInput() {
      this.$refs.modal_sizeInput.hide();
    },

    sizeInput() {
      this.shipment_record_obj.products[this.updating_item_i] = JSON.parse(
        JSON.stringify(this.updating_item)
      );
      this.$refs.modal_sizeInput.hide();
    },

    showModal_weightInput(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item_i = item_i;
      this.$refs.modal_weightInput.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_weightInput() {
      this.$refs.modal_weightInput.hide();
    },

    weightInput() {
      this.shipment_record_obj.products[this.updating_item_i] = JSON.parse(
        JSON.stringify(this.updating_item)
      );
      this.$refs.modal_weightInput.hide();
    },

    showModal_ExpDateInput(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item.expiration_date = moment(item.expiration_date).format(
        "YYYY-MM-DD"
      );
      this.updating_item_i = item_i;
      this.$refs.modal_ExpDateInput.show();
    },

    hideModal_ExpDateInput() {
      this.$refs.modal_ExpDateInput.hide();
    },

    showModal_printQty(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item.qty_to_print = item.expected_qty;
      this.updating_item_i = item_i;
      this.$refs.modal_printQty.show();
    },

    hideModal_printQty() {
      this.$refs.modal_printQty.hide();
    },

    doExpDateInput() {
      console.log(this.updating_item.expiration_date);
      if (
        !this.updating_item.expiration_date ||
        this.updating_item.expiration_date == "" ||
        this.updating_item.expiration_date == "Invalid date"
      ) {
        this.updating_item.expiration_date = null;
      }

      // auto set lot#
      let exp_yyyymmdd = moment(this.updating_item.expiration_date).format(
        "YYMMDD"
      );
      this.updating_item.lot_number = exp_yyyymmdd;

      // this.shipment_record_obj.products[this.updating_item_i] = JSON.parse(
      //   JSON.stringify(this.updating_item)
      // );
      // console.log(this.shipment_record_obj.products[this.updating_item_i]);
      this.$refs.modal_ExpDateInput.hide();
    },

    async printSKU(item) {
      let self = this;
      this.$http({
        url: this.NODEJS_API_URL + "/print_mini_barcode",
        method: "POST",
        data: {
          barcodes: [item.product_sku],
          qty_to_print: item.qty_to_print,
          user_id: this.$store.state.user_obj.user_id,
        },
      }).then((response) => {
        self.pdf_to_print =
          process.env.NODEJS_PDF_URL + "/sku_" + item.product_sku + ".pdf";
        console.log(self.pdf_to_print);

        setTimeout(() => {
          let objFra = document.getElementById("myFrame_sku");
          objFra.contentWindow.focus();
          objFra.contentWindow.print();
        }, 4000);

        setTimeout(() => {
          self.loader.hide();
          self.cleanupFormData();

          fetch(self.pdf_to_print).then(function (t) {
            return t.blob().then((b) => {
              var a = document.createElement("a");
              a.href = URL.createObjectURL(b);
              a.setAttribute("download", self.pdf_to_print.split("/").pop());
              a.click();
            });
          });
        }, 6000);

        this.hideModal_printQty();
      });
    },

    onPageChange_ShipmentRecord(page_to_change) {
      this.table_offset_ShipmentRecord = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getInbound_Shipment_DN();
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.file_document {
  display: none;
}

.preview_img-product {
  max-width: 100%;
  max-height: 200px;
}

.container-preview_img {
  padding: 5px;
}

.icon-add_image {
  color: #cacaca;
}

.modal-dialog.modal-xl {
  max-width: 95%;
}

.td_maxwidth300x {
  max-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/InboundShipment.vue